module.exports = __webpack_public_path__ + "static/media/blog.7f3bec17.jpg";